import { combineReducers } from "redux";

import Login from "./auth/loginReducer";
import Logout from "./auth/logoutReducer";
import VerifyEmail from "./auth/verifyEmailReducer";
import AddNewAddress from "./auth/addNewAddressReducer";
import GetUsersList from "./auth/getUsersListReducer";

import CompleteKYC from "./kyc/completeKYCReducer";
import KYCAuthReducer from "./kyc/kycAuthReducer";

import GetBalance from "./dashboard/getBalanceReducer";
import GetUserData from "./dashboard/getUserdataReducer";
import DepositMoneyPlant from "./dashboard/depositMoneyPlantReducer";
import CurrentScreenWidth from "./dashboard/setScreenWidthReducer";

import Reports from "./monumpay/reportsReducer";
import ReportInfo from "./monumpay/reportInfoReducer";
import Refund from "./monumpay/refundReducer";

import WithdrawalList from "./transaction/withdrawalListReducer";
import DepositList from "./transaction/depositListReducer";

import TransactionsList from "./transaction/getAllTransaction";
import AllTradesList from "./transaction/allTradesReducer";
import UpdateWithdrawStatus from "./transaction/updateWithdrawStatus";
import CurrencyPairs from "./transaction/currencyPairsReducer";

import UpdateUserStatus from "./auth/updateUserStatusReducer";
import DeleteUser from "./auth/deleteUserReducer";
import ChangeUserPassword from "./auth/changeUserPasswordReducer";
import GetKycDetails from "./kyc/getKycDetailsReducer";
import Addwhitelabel from "./whitelabels/whitelabelsReducer";
import GetWhiteLabel from "./whitelabels/getWhitelabelReducer"
import DeletedUsers from "./deletedusers/deletedusers"
import AddBanking from "./whitelabels/addBankingReducer"
import GetPartnerAccount from "./dashboard/getPartnerAccountReducer"
import { adminSubmitKycReducer } from "./auth/adminSubmitKycReducer"
import { getCorporateDataReducer, updateCorporateStatusReducer } from "./corporate/index.js"
import UpdatePromoCode from "./auth/updatePromoCodeReducer"
import SearchUsers from "./auth/searchUsersReducer"
import UpdateUserRef from "./dashboard/updateUserRefReducer"

const appReducer = combineReducers({
  Login,
  Logout,
  CompleteKYC,
  KYCAuthReducer,
  GetBalance,
  GetUserData,
  DepositMoneyPlant,
  VerifyEmail,
  AddNewAddress,
  GetUsersList,
  CurrentScreenWidth,
  Reports,
  ReportInfo,
  Refund,
  WithdrawalList,
  DepositList,
  TransactionsList,
  AllTradesList,
  UpdateWithdrawStatus,
  UpdateUserStatus,
  DeleteUser,
  GetKycDetails,
  ChangeUserPassword,
  Addwhitelabel,
  GetWhiteLabel,
  DeletedUsers,
  AddBanking,
  GetPartnerAccount,
  CurrencyPairs,
  adminSubmitKyc: adminSubmitKycReducer,
  GetCorporateData: getCorporateDataReducer,
  UpdateCorporateStatus: updateCorporateStatusReducer,
  UpdatePromoCode,
  SearchUsers,
  UpdateUserRef,
});

const reducers = (state, action) => {
  return appReducer(state, action);
};

export default reducers;